const rememberedName = () => {
  try { return globalThis.localStorage?.getItem('eaxfuel.lastDisplayName') ?? ''; }
  catch (_error) { return ''; }
};

export function BrandedLoading({ displayName = null, label = 'Loading your data from the database…' }) {
  const name = String(displayName || rememberedName()).trim();

  return (
    <div className="startup-screen">
      <div className="startup-card" role="status" aria-live="polite">
        <div className="startup-brand">
          <img src="/favicon.png" alt="" width="48" height="48" />
          <div>
            <p className="startup-wordmark">EAX FUEL</p>
            <p className="startup-tagline">your day, <span>in balance</span></p>
          </div>
        </div>
        <div className="startup-copy">
          {name ? <p className="startup-welcome">Welcome, <strong>{name}</strong></p> : null}
          <p className="startup-status">{label}</p>
        </div>
        <div className="startup-progress" aria-hidden="true"><span /></div>
      </div>
    </div>
  );
}
